import {CoreDataLoaders, DataLoader, enumContainer, i18nContainer} from '@wallaby-ui/core';
import {
  // medicationsContainer,
  numberRangeContainer,
  medicationsContainer,
} from '@wallaby-ui/document';

import AppConfig from './app_config';

// NOTE: fetch without auth
export const CoreDataConfig: CoreDataLoaders = {
  enums: [
    {
      id: 'wallaby-core',
      apiUrl: AppConfig.service.url.coreEnums,
      component: enumContainer.EnumLoader,
    },
    {
      id: 'merie',
      apiUrl: AppConfig.service.url.merieEnums,
      component: enumContainer.EnumLoader,
    },
    {
      id: 'merieHierarchical',
      apiUrl: AppConfig.service.url.merieEnumsHierarchical,
      component: enumContainer.EnumLoader,
      isHierarchical: true,
    },
  ],
  translations: [
    {
      id: 'wallaby-core',
      apiUrl: AppConfig.service.url.coreTranslations,
      component: i18nContainer.TranslationsLoader,
    },
    {
      id: 'merie',
      apiUrl: AppConfig.service.url.merieTranslations,
      component: i18nContainer.TranslationsLoader,
    },
  ],
};

// NOTE: fetch with auth
export const AppDataConfig: DataLoader[] = [
  {
    id: 'numberRangeFilterData',
    apiUrl: AppConfig.service.url.numberRange,
    component: numberRangeContainer.NumberRangeLoader,
  },
  {
    id: 'medicationsFilterData',
    apiUrl: AppConfig.service.url.medicationsFilterData,
    component: medicationsContainer.MedicationsLoader,
  },
  /*
  {
    id: 'snomed-current',
    apiUrl: AppConfig.service.url.snomedLabels,
    component: PrefetchLoader,
    useLocale: true,
  },
  {
    id: 'snomed-en',
    apiUrl: AppConfig.service.url.snomedLabels,
    component: PrefetchLoader,
    useLocale: 'en',
  },
  */
];
